import useModal from '../../../lib/hooks/useModal'

import TermsOfServiceModal from './TermsOfServiceModal'

type TermsOfServiceModalWrapperProps = {
  isOpen: boolean
}

const TermsOfServiceModalWrapper = ({ isOpen }: TermsOfServiceModalWrapperProps) => {
  const { hideModal } = useModal()
  const onCancel = () => {
    hideModal()
  }

  return <TermsOfServiceModal isOpen={isOpen} onCancel={onCancel} />
}

export default TermsOfServiceModalWrapper
